<div class="ag-form-control" #viewControl matTooltip="{{ !!hint && formGroup.invalid && formGroup.dirty ? hint : null }}" [class.has-errors]="formGroup.invalid && formGroup.dirty" [formGroup]="formGroup">
  <div class="ag-value">
    <input style="top: 0 !important" type="number" formControlName="value" step="0.01" placeholder=" " />
    <label for="value">{{ label }}</label>
  </div>
  <div class="ag-selector">
    {{ unit }}
  </div>
</div>
